import { ReactNode } from 'react';
import { Form, Select, SelectProps } from 'antd';
import ImageC from 'src/components/Image';
import classes from './index.module.less';
interface DataType {
  value: any;
  label?: ReactNode;
  disabled?: boolean;
}
type Size = 'large' | 'middle' | 'small';
export type SelectCProps = SelectProps<any> & {
  WithoutForm?: boolean;
  showSearch?: boolean;
  allowClear?: boolean;
  name: string;
  options: DataType[];
  initialValue?: any;
  defaultValue?: any;
  value?: any;
  disabled?: boolean;
  useLabel?: boolean;
  label?: any;
  className?: string;
  dropdownClassName?: string;
  optionClassName?: string;
  rules?: object[];
  placeholder?: string | ReactNode;
  loading?: boolean;
  mode?: 'multiple' | 'tags';
  size?: Size;
  open?: boolean;
  onChange?: (e?: any) => void;
};
export const addSuffix = (prefix?: string, text?: string) => {
  return <div className={classes.suffix}>
			<ImageC width={20} height={20} alt="suffix" src={prefix} />
			<p>{text}</p>
		</div>;
};
const SelectC = (props: SelectCProps) => {
  const useLabel = props.useLabel ? props.label : '';
  const isRequired = props.rules ? props.rules.filter((r: any) => r.required === true).length > 0 : false;
  const filterOption = (input: string, option: any) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  const SelectWrapper = (v: any) => {
    return <Select showSearch={props.showSearch} filterOption={props.showSearch ? filterOption : undefined} allowClear={props.allowClear} size={props.size} defaultValue={props.defaultValue} className={props.className} dropdownClassName={props.dropdownClassName} value={v} disabled={props.disabled} placeholder={props.placeholder} loading={props.loading} mode={props.mode} open={props.open} onChange={props.onChange} style={props.style} dropdownStyle={props.dropdownStyle} options={props.options?.map(o => ({
      value: o.value,
      label: o.label,
      disabled: o.disabled ?? false
    }))} />;
  };
  return <>
			{props.WithoutForm ? <>{SelectWrapper(props.initialValue)}</> : <Form.Item label={useLabel} name={props.name} required={isRequired} rules={props.rules} initialValue={props.initialValue} className={classes['select-input-box']}>
					{SelectWrapper(props.value)}
				</Form.Item>}
		</>;
};
export default SelectC;